/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exams_TitleInputs */

const da_exams_title = /** @type {(inputs: Exams_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prøver`)
};

/** @type {(inputs: Exams_TitleInputs) => LocalizedString} */
const en_exams_title = da_exams_title;

/**

* @param {Exams_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const exams_title = /** @type {((inputs?: Exams_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exams_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exams_title(inputs)
	return /** @type {LocalizedString} */ ("Prøver")
});